import { createElementBlock as o, openBlock as e, createElementVNode as r } from "vue";
import c from "./index289.js";
const l = {}, n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function s(a, t, p, m, f, i) {
  return e(), o("svg", n, t[0] || (t[0] = [
    r("path", {
      fill: "currentColor",
      d: "M12.046 1c2.93.001 5.68 1.137 7.749 3.197A10.812 10.812 0 0 1 23 11.91c-.003 5.915-4.762 10.746-10.667 10.898l-.287.003a10.98 10.98 0 0 1-5.239-1.327L1.001 23l1.553-5.649a10.846 10.846 0 0 1-1.462-5.45C1.095 5.89 6.008 1 12.046 1Zm.003 1.841c-5.022 0-9.106 4.065-9.108 9.06 0 1.712.48 3.38 1.392 4.822l.217.343-.92 3.344 3.446-.9.333.197a9.13 9.13 0 0 0 4.634 1.263c5.021 0 9.106-4.065 9.108-9.061a8.985 8.985 0 0 0-2.665-6.41A9.067 9.067 0 0 0 12.05 2.84ZM7.821 7c.197 0 .394 0 .566.006.21.008.443.016.664.458.263.525.837 1.837.91 1.97.074.133.124.287.025.465-.098.177-.148.287-.295.442-.148.155-.31.346-.443.465-.149.132-.302.276-.13.54.172.267.765 1.135 1.643 1.838 1.127.904 2.079 1.184 2.374 1.316.295.133.467.11.64-.066.172-.177.738-.775.934-1.04.197-.266.394-.221.665-.133.27.088 1.722.73 2.017.863.295.133.492.2.566.31.074.11.074.642-.172 1.261-.247.62-1.452 1.217-1.993 1.261l-.112.01c-.51.054-1.11.149-3.431-.674-3.001-1.063-4.896-3.827-5.043-4.004l-.03-.035-.092-.114C6.764 11.73 6 10.654 6 9.544c0-1.305.763-1.947 1.033-2.212.271-.265.59-.332.788-.332Z"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ c(l, [["render", s]]);
export {
  u as default
};
